module.exports = __webpack_public_path__ + "static/logo-8a1a33a6be1c5bf4dbfe07631d7735a8.svg";